(function () {
  function labelJudgeMeImages() {
    document.querySelectorAll('[class*="jdgm"] img').forEach(function (img) {
      if (img.getAttribute('alt') === null) {
        img.setAttribute('alt', 'Customer review photo');
      }
    });
  }

  function labelJudgeMeArrows() {
    document.querySelectorAll('.jdgm-arrow--left, .jdgm-arrow.jdgm-prev').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')) {
        btn.setAttribute('aria-label', 'Previous review');
      }
    });
    document.querySelectorAll('.jdgm-arrow--right, .jdgm-arrow.jdgm-next').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')) {
        btn.setAttribute('aria-label', 'Next review');
      }
    });
  }

  function hideJudgeMeClones() {
    document.querySelectorAll('.jdgm-clone').forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function applyAll() {
    labelJudgeMeImages();
    labelJudgeMeArrows();
    hideJudgeMeClones();
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyAll();
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(applyAll).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  });
})();
